import { Link, Outlet } from "react-router-dom";
import { Button, Container, OwlMark, Wordmark } from "@wiseowl/design-system";
import { clearReflectionOnly } from "../lib/anon-reflection.js";
import { isEmbedded } from "../lib/embed.js";

/** Clear today's device reflection and reload the landing to retake it. */
const resetTodaysReflection = () => {
  clearReflectionOnly();
  window.location.assign("/");
};

export const MarketingLayout = () => isEmbedded() ? (
  // Embedded in wiseowltalks.com: no header/footer, the host page frames it.
  <main className="text-ink">
    <Outlet />
  </main>
) : (
  <div className="flex min-h-screen flex-col bg-cream text-ink">
    <header className="sticky top-0 z-10 border-b border-line bg-cream/85 backdrop-blur">
      <Container className="flex h-14 items-center justify-between md:h-16">
        <Link to="/" aria-label="Wise Owl Talks home" className="flex items-center gap-2.5">
          <OwlMark size={30} />
          <Wordmark size={19} />
        </Link>
        {/* Mobile: minimal — a single quiet sign-in link so the reflection
            stays the focus. Desktop: the full nav. */}
        <Link to="/sign-in" className="text-small font-medium text-ink-soft hover:text-teal md:hidden">
          Sign in
        </Link>
        <nav className="hidden items-center gap-2 md:flex">
          <Link to="/sign-in">
            <Button variant="ghost" size="sm">Sign in</Button>
          </Link>
          <Link to="/sign-up">
            <Button size="sm">Start a quieter day</Button>
          </Link>
        </nav>
      </Container>
    </header>

    <main className="flex-1">
      <Outlet />
    </main>

    <footer className="border-t border-line bg-paper">
      <Container className="flex flex-col gap-3 py-5">
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-small font-medium text-ink-soft">
          <Link to="/sign-up" className="hover:text-teal">Sign up</Link>
          <Link to="/sign-in" className="hover:text-teal">Sign in</Link>
          <Link to="/how-it-works" className="hover:text-teal">How it works</Link>
        </nav>
        <div className="flex flex-col items-center justify-between gap-2 border-t border-line pt-3 text-meta text-muted md:flex-row">
          <span>&copy; {new Date().getFullYear()} Wise Owl Talks · A wise pause in a noisy world.</span>
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <button type="button" onClick={resetTodaysReflection} className="hover:text-teal">
              Reset today&apos;s reflection
            </button>
            <Link to="/terms" className="hover:text-teal">Terms</Link>
            <Link to="/privacy" className="hover:text-teal">Privacy</Link>
            <Link to="/analytics" className="hover:text-teal">Analytics</Link>
          </nav>
        </div>
      </Container>
    </footer>
  </div>
);
